function readMore1() {
  var moreText1 = document.getElementById("more1");
  var btnText1 = document.getElementById("moreBtn1");
  
    btnText1.style.display = "none";
    moreText1.style.display = "inline";
} 

function readMore2() {
  var moreText2 = document.getElementById("more2");
  var btnText2 = document.getElementById("moreBtn2");

    btnText2.style.display = "none";
    moreText2.style.display = "inline";
} 

function readMore3() {
  var moreText3 = document.getElementById("more3");
  var btnText3 = document.getElementById("moreBtn3");

    btnText3.style.display = "none";
    moreText3.style.display = "inline";
} 

function readLess1() {
  var moreText1 = document.getElementById("more1");
  var btnText1 = document.getElementById("moreBtn1");

    btnText1.style.display = "inline";
    moreText1.style.display = "none";
} 

function readLess2() {
  var moreText2 = document.getElementById("more2");
  var btnText2 = document.getElementById("moreBtn2");

    btnText2.style.display = "inline";
    moreText2.style.display = "none";
} 

function readLess3() {
  var moreText3 = document.getElementById("more3");
  var btnText3 = document.getElementById("moreBtn3");

    btnText3.style.display = "inline";
    moreText3.style.display = "none";
} 